<template lang="pug">
    #dashboard-pssc
        BaseHeader(
            :titulo="$t('mensagens.pssc.telaDashboard.titulo')",
            :exibeBotao='false'
            @btnHeaderClicado=""
        )
            div(slot="direita" style="display:flex; align-items:center; justify-content: flex-end; gap:10px; width: 450px")
                div {{ $t('mensagens.pssc.telaLista.selectLote') }}
                el-select(
                    v-model='payload.filtros.payload.lotes',
                    filterable, multiple, value-key='id',
                    popper-class="custom-header"
                    :placeholder="$t('mensagens.pssc.telaLista.filtros.labelLotes')"
                    @change="fetchDadosDashboard()"
                    collapse-tags
                    style="min-width: 250px"
                )
                    template(id='header')
                        el-checkbox(
                            v-model="selecionar_todas_carteiras"
                            :indeterminate="selecionar_todas_carteiras_indeterminado"
                            @change="selecionarTodasCarteiras"
                        )
                            | Selecionar tudo
                    el-option(
                        v-for='(lote, index) in lotes',
                        :key='index',
                        :label='lote.nome',
                        :value='lote.id'
                        style="max-width: 250px"
                    ) {{ lote.nome }}

        .view-container-base-header
            .dashboard__container
                section.indicadores__first-row__grid
                    div(v-loading='loadingOverview').indicador__card
                        .titulo-indicador(style="text-align: start; width: 100%; display: flex; align-items: center")
                            span {{ $t('mensagens.pssc.telaDashboard.overview') }}
                        .totalizadores__container
                            .totalizador-overview__card
                                .totalizador-icon
                                    img(src="@/assets/lyra-icons/pssc/totalizador-imoveis.svg").mr-2
                                .totalizador-label
                                    span {{ $t('mensagens.pssc.telaDashboard.territoriosProcessados') }}
                                .totalizador-valor.territorios-processados
                                    span {{ this.dadosOverview.totalTerritorios }}
                            .totalizador-overview__card
                                .totalizador-icon
                                    img(src="@/assets/lyra-icons/pssc/totalizador-conforme.svg").mr-2
                                .totalizador-label
                                    span {{ $t('mensagens.pssc.telaDashboard.semPendenciaAmbiental') }}
                                .totalizador-valor.territorios-conformes
                                    span {{ this.dadosOverview.totalSemPendencia }}
                            .totalizador-overview__card
                                .totalizador-icon
                                    img(src="@/assets/lyra-icons/pssc/totalizador-inconforme-dashboard.svg").mr-2
                                .totalizador-label
                                    span {{ $t('mensagens.pssc.telaDashboard.necessarioRegularixacaoAmbiental') }}
                                .totalizador-valor.territorios-regularizacao-ambiental
                                    span {{ this.dadosOverview.totalComPendencia }}
                            .totalizador-overview__card
                                .totalizador-icon
                                    img(src="@/assets/lyra-icons/pssc/totalizador-inconforme.svg").mr-2
                                .totalizador-label
                                    span {{ $t('mensagens.pssc.telaDashboard.inconforme') }}

                                    el-tooltip.tooltip-inconforme(effect='light', placement='right')
                                        span(slot='content')
                                            .tooltip-content.tooltip-inconforme-descricao
                                                p {{ $t('mensagens.pssc.telaDashboard.tooltipDescricaoInconforme') }}
                                        span
                                            i.information-card.mdi.mdi-information-outline.criterio-fora-regiao.icone
                                .totalizador-valor.territorios-inconformes
                                    span {{ this.dadosOverview.totalInconforme }}

                    div(v-loading='loadingGraficoAreaTotal').indicador__card
                        .titulo-indicador(style="text-align: start; width: 100%; display: flex; align-items: center").indicador-area-total
                            div.titulo-indicador-principal
                                span {{ $t('mensagens.pssc.telaDashboard.areaTotalHa') }}
                            div(v-if='dadosAreaTotal.dados').titulo-indicador-valor-totalComPendencia
                                span {{ formatNumber(dadosAreaTotal.dados.areaTotalHa) + ' ha' }}
                        apex-charts(v-if='serieAreaTotal').grafico-area-total_container.apexcharts-canvas(
                            type='treemap',
                            height='320',
                            :width='atualizarProporcaoGraficoArea()',
                            :options='optionsAreaTotal',
                            :series='serieAreaTotal',
                            ref='chart'
                        )

                    div(v-loading='loadingTerritorio').indicador__card
                        .titulo-indicador(style="text-align: start; width: 100%; display: flex; align-items: center")
                            span {{ $t('mensagens.pssc.telaDashboard.territorio.titulo') }}
                        apex-charts(v-if='optionsChartTerritorio.series.length > 0').grafico-territorios_container.apexcharts-canvas(
                            type='pie',
                            width='100%',
                            height='354',
                            :options='optionsChartTerritorio',
                            :series='optionsChartTerritorio.series',
                            ref='chart'
                        )
                        div(v-else style="height: 100%; width: 100%; display: flex; align-items: center; justify-content: center")
                            span(style="color: #3b3b3b; font-size: 12px; margin-top: -10px; opacity: 0.7; font-weight: 500")
                                | {{ $t('mensagens.pssc.telaDashboard.areaTotal.nenhumTerritorioProcessado') }}

                section.indicadores__second-row__grid
                    div(v-loading='loadingTrilha').indicador__card
                        .indicadores__second-row__grid__titulo
                            span {{ $t('mensagens.pssc.telaDashboard.trilha.trilhas') }}
                        .indicadores__second-row__grid__subtitulo
                            span {{ $t('mensagens.pssc.telaDashboard.trilha.subtituloTrilhas') }}
                        .totalizadores__container
                            div(style="display: grid; justify-items: center; height: 100%; align-content: space-evenly")
                                section.indicadores__second-row__grid__grid
                                    img(src="@/assets/lyra-icons/pssc/produzidas-trilha-dashboard.svg", height="40px")
                                    img(src="@/assets/lyra-icons/pssc/linha-trilha-dashboard.svg")
                                    img(src="@/assets/lyra-icons/pssc/enviadas-trilha-dashboard.svg", height="40px")
                                    img(src="@/assets/lyra-icons/pssc/linha-trilha-dashboard.svg")
                                    img(src="@/assets/lyra-icons/pssc/visualizadas-trilha-dashboard.svg", height="40px")
                                section.indicadores__second-row__grid__grid
                                    div
                                        div.indicadores__second-row__grid__grid__titulo
                                            | {{ $t('mensagens.pssc.telaDashboard.trilha.produzidas') }}
                                        span.indicadores__second-row__grid__grid__valor {{ optionsTrilha.produzidas }}
                                    div
                                    div
                                        div.indicadores__second-row__grid__grid__titulo
                                            | {{ $t('mensagens.pssc.telaDashboard.trilha.enviadas') }}
                                        span.indicadores__second-row__grid__grid__valor {{ optionsTrilha.enviadas }}
                                    div
                                    div
                                        div.indicadores__second-row__grid__grid__titulo
                                            | {{ $t('mensagens.pssc.telaDashboard.trilha.visualizadas') }}
                                        span.indicadores__second-row__grid__grid__valor {{ optionsTrilha.visualizadas }}

                section.indicadores__third-row__grid
                    div(v-loading='loadingTotalizadorCoberturaSolo').indicador__card
                        .indicadores__third-row__grid__titulo
                            span {{ $t('mensagens.pssc.telaDashboard.coberturaSolo.titulo') }}
                        section(v-if='serieCoberturaSolo').grafico-cobertura-solo__container
                            div.legenda-lateral-cobertura-solo
                                div(:style='getStyleCategoria("area_consolidada_total")').item-legenda {{ $t('mensagens.pssc.telaDashboard.coberturaSolo.areaConsolidadaTotal') }}
                                div(:style='getStyleCategoria("area_total_vegetacao_nativa")').item-legenda {{ $t('mensagens.pssc.telaDashboard.coberturaSolo.areaTotalVegetacaoNativa') }}
                                div(:style='getStyleCategoria("area_total_desmatamento")').item-legenda {{ $t('mensagens.pssc.telaDashboard.coberturaSolo.areaTotalComDesmatamento') }}
                            apex-charts.grafico-cobertura-solo.apexcharts-canvas(
                                type='bar',
                                height='272',
                                :options='optionsCoberturaSolo',
                                :series='serieCoberturaSolo',
                                ref='chart'
                            )
                        section(v-else style="height: 100%; width: 100%; display: flex; align-items: center; justify-content: center")
                            span(style="color: #3b3b3b; font-size: 12px; margin-top: -10px; opacity: 0.7; font-weight: 500")
                                | {{ $t('mensagens.pssc.telaDashboard.areaTotal.nenhumTerritorioProcessado') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import PSSCService from '@/services/PSSCService';
import ApexCharts from 'vue-apexcharts';

import formatters from '@/utils/formatters';

export default {
    name: 'DashboardPssc',
    components: {
        BaseHeader,
        ApexCharts
    },
    data() {
        return {
            payload: {
                filtros: {
                    payload: {
                        lotes: []
                    }
                }
            },
            selecionar_todas_carteiras: true,
            selecionar_todas_carteiras_indeterminado: false,
            lotes: [],
            dadosOverview: {},
            loadingOverview: false,
            loadingTrilha: false,
            loadingTerritorio: false,
            loadingTotalizadorCoberturaSolo: false,
            optionsTrilha: {
                produzidas: 0,
                enviadas: 0,
                visualizadas: 0
            },
            optionsChartTerritorio: {
                noData: {
                    text: this.$t('mensagens.pssc.telaDashboard.areaTotal.nenhumTerritorioProcessado'),
                    align: 'center',
                    verticalAlign: 'middle',
                    offsetX: 0,
                    offsetY: -8,
                    style: {
                        color: '#7C7C7C',
                        fontSize: '12px',
                        fontFamily: 'Roboto, sans serif',
                        fontWeight: '400'
                    }
                },
                series: [],
                labels: [],
                colors: ['#00413b', '#40716d', '#7f9f9c', '#bfcfcd'],
                legend: {
                    position: 'bottom',
                    horizontalAlign: 'center',
                    fontSize: '11px'
                },
                tooltip: {
                    theme: 'dark',
                    followCursor: true,
                    custom: (this.$t, ({series, seriesIndex, dataPointIndex, w}) => {
                        let territorioString = series[seriesIndex] > 1
                            ? this.$t('mensagens.pssc.telaDashboard.territorio.territorioPlural')
                            : this.$t('mensagens.pssc.telaDashboard.territorio.territorioSingular');
                        return (
                            '<div class="tooltip-territorios-content">' +
                            '<p class="tooltip-territorios-label">' +
                            w.globals.labels[seriesIndex] +
                            ':' +
                            '</p>' +
                            '<p class="tooltip-territorios-value">' +
                            series[seriesIndex] + ' ' +
                            territorioString +
                            '</p>' +
                            '</div>'
                        );
                    })
                },
                dataLabels: {
                    style: {
                        fontSize: '14px'
                    },
                    formatter(val) {
                        return val.toFixed(1) + '%';
                    }
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        }
                    }
                }
            },
            optionsAreaTotal: {},
            serieAreaTotal: null,
            dadosAreaTotal: {},
            loadingGraficoAreaTotal: false,
            categoriasAreaTotal: [
                {
                    nome: this.$t('mensagens.pssc.telaDashboard.areaTotal.inconforme'),
                    codigo: 'areaHaInconforme',
                    cor: 'rgba(255, 0, 0, 0.25)'
                },
                {
                    nome: this.$t('mensagens.pssc.telaDashboard.areaTotal.necessarioRegularizacaoAmbiental'),
                    codigo: 'areaHaComPendencia',
                    cor: 'rgba(248, 131, 66, 0.25)'
                },
                {
                    nome: this.$t('mensagens.pssc.telaDashboard.areaTotal.semPendenciaAmbiental'),
                    codigo: 'areaHaSemPendencia',
                    cor: 'rgba(53, 145, 56, 0.25)'
                }
            ],
            serieCoberturaSolo: null,
            optionsCoberturaSolo: {},
            dadosCoberturaSolo: {
                inconforme: {
                    area_consolidada_total: 0,
                    area_total_vegetacao_nativa: 0,
                    area_total_desmatamento: 0
                },
                sem_pendencia_ambiental: {
                    area_consolidada_total: 0,
                    area_total_vegetacao_nativa: 0,
                    area_total_desmatamento: 0
                },
                com_necessidade_regularizacao_ambiental: {
                    area_consolidada_total: 0,
                    area_total_vegetacao_nativa: 0,
                    area_total_desmatamento: 0
                }
            },
            categoriasCoberturaDoSolo: {
                categorias: [
                    {
                        nome: this.$t('mensagens.pssc.telaDashboard.coberturaSolo.areaConsolidadaTotal'),
                        cor: '#FFBF5B',
                        codigo: 'area_consolidada_total'
                    },
                    {
                        nome: this.$t('mensagens.pssc.telaDashboard.coberturaSolo.areaTotalVegetacaoNativa'),
                        cor: '#21892D',
                        codigo: 'area_total_vegetacao_nativa'
                    },
                    {
                        nome: this.$t('mensagens.pssc.telaDashboard.coberturaSolo.areaTotalComDesmatamento'),
                        cor: '#E64510',
                        codigo: 'area_total_desmatamento'
                    }
                ],
                series: [
                    {
                        nome: this.$t('mensagens.pssc.telaDashboard.coberturaSolo.semPendenciaAmbiental'),
                        codigo: 'sem_pendencia_ambiental'
                    },
                    {
                        nome: this.$t('mensagens.pssc.telaDashboard.coberturaSolo.comNecessidadeRegularizacaoAmbiental'),
                        codigo: 'com_necessidade_regularizacao_ambiental'
                    },
                    {
                        nome: this.$t('mensagens.pssc.telaDashboard.coberturaSolo.inconforme'),
                        codigo: 'inconforme'
                    }
                ]
            }
        };
    },
    watch: {
        'payload.filtros.payload.lotes'(val) {
            if (val.length === 0) {
                this.selecionar_todas_carteiras = false;
                this.selecionar_todas_carteiras_indeterminado = false;
            } else if (val.length === this.lotes.length) {
                this.selecionar_todas_carteiras = true;
                this.selecionar_todas_carteiras_indeterminado = false;
            } else {
                this.selecionar_todas_carteiras_indeterminado = true;
            }
        }
    },
    mounted() {
        this.fetchLotes();
        this.fetchDadosDashboard();
    },
    methods: {
        fetchDadosDashboard() {
            this.fetchOverview();
            this.fetchTotalizadorTrilhas();
            this.fetchTotalizadorTerritorio();
            this.fetchTotalizadorCoberturaSolo();
            this.fetchDadosAreaTotal();
        },
        async fetchLotes() {
            try {
                const {data} = await PSSCService.buscarLotes();
                this.lotes = data.itens;
                this.payload.filtros.payload.lotes = data.itens.map(item => item.id);
            } catch {
                this.exibirNotify(
                    'error',
                    this.$t('mensagens.pssc.telaDashboard.erroBuscarLotes')
                );
            }
        },
        async fetchOverview() {
            this.loadingOverview = true;
            await PSSCService.buscarVisaoGeral(this.payload.filtros.payload)
                .then(({data}) => {
                    this.dadosOverview = data.overview;
                })
                .catch(() => {
                    this.exibirNotify(
                        'error',
                        this.$t('mensagens.pssc.telaDashboard.erroOverview')
                    );
                });
            this.loadingOverview = false;
        },
        async fetchTotalizadorTrilhas() {
            this.loadingTrilha = true;
            await PSSCService.buscarTotalizadorTrilhas(this.payload.filtros.payload)
                .then(({data}) => {
                    this.optionsTrilha = data;
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.pssc.telaDashboard.trilha.erroBuscarTrilha')
                    });
                })
                .finally(() => {
                    this.loadingTrilha = false;
                });
        },
        async fetchTotalizadorTerritorio() {
            this.loadingTerritorio = true;
            await PSSCService.buscarTotalizadorTerritorio(this.payload.filtros.payload)
                .then(({data}) => {
                    if (Object.values(data).some(item => item !== 0)) {
                        this.optionsChartTerritorio.series = [];

                        this.optionsChartTerritorio.series[0] = data.ate50Ha;
                        this.optionsChartTerritorio.series[1] = data.entre50e500Ha;
                        this.optionsChartTerritorio.series[2] = data.entre500e1000Ha;
                        this.optionsChartTerritorio.series[3] = data.acima1000Ha;

                        this.optionsChartTerritorio.labels[0] = this.$t('mensagens.pssc.telaDashboard.territorio.ate50ha');
                        this.optionsChartTerritorio.labels[1] = this.$t('mensagens.pssc.telaDashboard.territorio.entre50e500Ha');
                        this.optionsChartTerritorio.labels[2] = this.$t('mensagens.pssc.telaDashboard.territorio.entre500e1000Ha');
                        this.optionsChartTerritorio.labels[3] = this.$t('mensagens.pssc.telaDashboard.territorio.acima1000Ha');
                    } else {
                        this.optionsChartTerritorio.series = [];
                        this.optionsChartTerritorio.labels = [];
                    }
                })
                .catch(() => {
                    this.exibirNotify(
                        'error',
                        this.$t('mensagens.pssc.telaDashboard.territorio.erroBuscar')
                    );
                })
                .finally(() => {
                    this.loadingTerritorio = false;
                });
        },
        async fetchTotalizadorCoberturaSolo() {
            this.loadingTotalizadorCoberturaSolo = true;
            await PSSCService.buscarTotalizadorCoberturaSoloDashboard(this.payload.filtros.payload)
                .then(({data}) => {
                    this.dadosCoberturaSolo = data;
                    this.configurarGraficoCoberturaDoSolo();
                })
                .catch(() => {
                    this.exibirNotify(
                        'error',
                        this.$t('mensagens.pssc.telaDashboard.coberturaSolo.erroBuscar')
                    );
                })
                .finally(() => {
                    this.loadingTotalizadorCoberturaSolo = false;
                });
        },
        async fetchDadosAreaTotal() {
            this.loadingGraficoAreaTotal = true;
            await PSSCService.buscarDadosAreaTotal(this.payload.filtros.payload)
                .then(({data}) => {
                    this.dadosAreaTotal = data;
                    this.configurarGraficoAreaTotal();
                })
                .catch(() => {
                    this.exibirNotify(
                        'error',
                        this.$t('mensagens.pssc.telaDashboard.areaTotal.erroBuscarDadosAreaTotal')
                    );
                })
                .finally(() => {
                    this.loadingGraficoAreaTotal = false;
                });
        },
        configurarGraficoAreaTotal() {
            this.loadingGraficoAreaTotal = true;

            if (this.dadosAreaTotal.dados !== null) {
                var series = [];
                this.categoriasAreaTotal.forEach((categoria, index) => {
                    let serie = {
                        name: '',
                        color: '',
                        data: [{
                            x: '',
                            y: 0
                        }, {
                            x: '',
                            y: 0
                        }, {
                            x: '',
                            y: 0
                        }]
                    };
                    serie.name = categoria.nome;
                    serie.color = categoria.cor;
                    serie.data[index].x = categoria.nome;
                    serie.data[index].y = this.dadosAreaTotal.dados[categoria.codigo];
                    series.push(serie);
                });
                this.serieAreaTotal = series;

                this.optionsAreaTotal.tooltip = {
                    theme: 'dark',
                    followCursor: true,
                    custom: function ({series, seriesIndex, dataPointIndex, w}) {
                        return (
                            '<div class="tooltip-area-total-content">' +
                            '<p class="tooltip-area-total-label">' +
                            w.globals.initialSeries[seriesIndex].data[dataPointIndex].x +
                            ':' +
                            '</p>' +
                            '<p class="tooltip-area-total-value">' +
                            formatters.formatNumber(w.globals.initialSeries[seriesIndex].data[dataPointIndex].y, 2) +
                            ' ha</p>' +
                            '</div>'
                        );
                    }
                };
            } else {
                this.serieAreaTotal = [];
            }

            this.optionsAreaTotal.plotOptions = {
                treemap: {
                    distributed: true,
                    enableShades: false,
                    dataLabels: {
                        format: 'scale'
                    }
                }
            };

            this.optionsAreaTotal.legend = {
                position: 'bottom',
                horizontalAlign: 'center',
                show: true,
                showForSingleSeries: true,
                fontSize: '11px',
                showForNullSeries: false
            };

            this.optionsAreaTotal.dataLabels = {
                enabled: true,
                textAnchor: 'middle',
                distributed: false,
                style: {
                    fontSize: '12px',
                    colors: ['#3b3b3b']
                },
                formatter: function (text, op) {
                    if (parseFloat(op.value) === 0.00 || !op.value) {
                        return '';
                    } else {
                        return formatters.formatNumber(op.value, 2) + ' ha';
                    }
                }
            };

            this.optionsAreaTotal.noData = {
                text: this.$t('mensagens.pssc.telaDashboard.areaTotal.nenhumTerritorioProcessado'),
                align: 'center',
                verticalAlign: 'middle',
                offsetX: 0,
                offsetY: -8,
                style: {
                    color: '#7C7C7C',
                    fontSize: '12px',
                    fontFamily: 'Roboto, sans serif',
                    fontWeight: '400'
                }
            };

            this.optionsAreaTotal.chart = {
                toolbar: {
                    show: false
                }
            };
            this.optionsAreaTotal.states = {
                hover: {
                    filter: {
                        type: 'none'
                    }
                }
            };
        },
        atualizarProporcaoGraficoArea() {
            const graficoAreaContainer = document.getElementsByClassName('grafico-area-total_container');
            if (graficoAreaContainer[0]) {
                return (graficoAreaContainer[0].clientWidth + 6).toString();
            } else {
                return '0';
            }
        },
        configurarGraficoCoberturaDoSolo() {
            if (this.dadosCoberturaSolo !== null) {
                this.serieCoberturaSolo = [];

                this.categoriasCoberturaDoSolo.categorias.forEach(categoria => {
                    let data = [];
                    this.categoriasCoberturaDoSolo.series.forEach(serie => {
                        data.push(this.dadosCoberturaSolo[serie.codigo][categoria.codigo]);
                    });
                    let dadosSerie = {
                        name: categoria.nome,
                        color: categoria.cor,
                        data: data
                    };
                    this.serieCoberturaSolo.push(dadosSerie);
                });
            }

            let categorias = [];
            this.categoriasCoberturaDoSolo.series.forEach(serie => {
                categorias.push(serie.nome);
            });
            this.optionsCoberturaSolo.xaxis = {
                categories: categorias,
                axisBorder: {
                    show: true,
                    color: 'rgba(238, 238, 238, 0.8)'
                },
                labels: {
                    style: {
                        fontSize: '14px',
                        fontFamily: 'Roboto, sans serif',
                        fontWeight: 500
                    }
                }
            };
            this.optionsCoberturaSolo.yaxis = {
                max: this.ajustarEscalaCoberturaDoSolo(),
                tickAmount: 6,
                labels: {
                    formatter: function (value) {
                        return formatters.formatNumber(Math.ceil(value), 0);
                    }
                },
                axisBorder: {
                    show: true,
                    color: 'rgba(204, 204, 204, 0.8)'
                }
            };
            this.optionsCoberturaSolo.plotOptions = {
                bar: {
                    columnWidth: '37px',
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    dataLabels: {
                        position: 'top'
                    },
                    colors: {
                        backgroundBarOpacity: 1
                    }
                }
            };
            this.optionsCoberturaSolo.dataLabels = {
                enabled: true,
                formatter: function (val) {
                    return formatters.formatNumber(val, 0);
                },
                offsetY: -20,
                style: {
                    fontSize: '12px',
                    fontWeight: '500',
                    fontFamily: 'Roboto, sans serif',
                    colors: ['#304758']
                }
            };
            this.optionsCoberturaSolo.tooltip = {
                theme: 'dark',
                followCursor: true,
                custom: function ({series, seriesIndex, dataPointIndex, w}) {
                    return (
                        '<div class="tooltip-cobertura-solo-content">' +
                            '<p class="tooltip-cobertura-solo-label">' +
                            w.globals.initialSeries[seriesIndex].name +
                            ':' +
                            '</p>' +
                            '<p class="tooltip-cobertura-solo-value">' +
                            formatters.formatNumber(w.globals.initialSeries[seriesIndex].data[dataPointIndex], 0) +
                            ' ha</p>' +
                        '</div>'
                    );
                }
            };
            this.optionsCoberturaSolo.chart = {
                toolbar: {
                    show: false
                }
            };
            this.optionsCoberturaSolo.legend = {
                show: false
            };
            this.optionsCoberturaSolo.grid = {
                show: true,
                borderColor: 'rgba(238, 238, 238, 0.8)'
            };
            this.optionsCoberturaSolo.states = {
                hover: {
                    filter: {
                        type: 'none'
                    }
                }
            };
            this.optionsCoberturaSolo.noData = {
                text: this.$t('mensagens.pssc.telaDashboard.areaTotal.nenhumTerritorioProcessado'),
                align: 'center',
                verticalAlign: 'middle',
                offsetX: 0,
                offsetY: -8,
                style: {
                    color: '#7C7C7C',
                    fontSize: '12px',
                    fontFamily: 'Roboto, sans serif',
                    fontWeight: '400'
                }
            };
        },
        ajustarEscalaCoberturaDoSolo() {
            const maiorValor = Math.max(...this.serieCoberturaSolo.flatMap(obj => obj.data));

            if (!maiorValor || parseFloat(maiorValor) === 0) return 10;

            let baseCalculo = Math.pow(10, maiorValor.toString().split('.')[0].length - 2);
            return Math.ceil((maiorValor * 1.1) / baseCalculo) * baseCalculo;
        },
        getStyleCategoria(codigoCategoria) {
            let categoria = this.categoriasCoberturaDoSolo.categorias.filter(c => c.codigo === codigoCategoria)[0];
            return 'color: ' + categoria.cor + ';';
        },

        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },
        selecionarTodasCarteiras(value) {
            if (value) {
                this.payload.filtros.payload.lotes = this.lotes.map(item => item.id);
                this.fetchDadosDashboard();
            } else {
                if (this.payload.filtros.payload.lotes.length !== this.lotes.length) {
                    this.fetchDadosDashboard();
                }
                this.payload.filtros.payload.lotes = [];
            }
        },
        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        }
    }
};
</script>

<style lang="scss">
#dashboard-pssc {
    height: 100%;
    width: 100%;

    .tooltip-value {
        text-align: center;
        margin: 6px 0;
        font-size: 12px;
        font-weight: 500;
        font-family: 'Roboto', 'sans serif' !important;
    }

    .apexcharts-tooltip {
        width: fit-content !important;
        margin: 0 4px;
        height: 40px !important;
    }

    .apexcharts-xaxis__style {
        font-weight: 500;
        width: 150px !important;
        word-wrap: break-word;
        word-break: break-all;
        break-inside: auto;
    }

    .view-container-base-header {
        .dashboard__container {
            display: flex;
            flex-direction: column;
            gap: 16px;

            .indicadores__first-row__grid {
                display: grid;
                grid-template-columns: auto 35% 35%;
                gap: 16px;
            }

            .indicadores__second-row__grid {
                display: grid;
                grid-template-columns: 100%;
                gap: 16px;
                height: 214px;

                .indicadores__second-row__grid__grid {
                    display: grid;
                    grid-template-columns: 127px 210px 127px 210px 127px;
                    justify-items: center;
                    align-items: center;
                    text-align: center;
                }

                .indicadores__second-row__grid__titulo {
                    height: fit-content !important;
                    font-size: 18px;
                    font-weight: 500;
                    color: #00413C;
                    text-align: start;
                    width: 100%;
                }

                .indicadores__second-row__grid__subtitulo {
                    height: fit-content !important;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(59, 59, 59, 1);
                    text-align: start;
                    width: 100%;
                    margin-bottom: 10px;
                }

                .indicadores__second-row__grid__grid__titulo {
                    font-size: 12px;
                }

                .indicadores__second-row__grid__grid__valor {
                    font-weight: 700;
                    font-size: 22px;
                    line-height: 25.78px;
                    color: rgba(53, 145, 56, 1);
                }
            }

            .indicadores__third-row__grid {
                display: grid;
                grid-template-columns: 100%;
                gap: 16px;
                height: fit-content;
                min-height: 346px;

                .indicadores__third-row__grid__titulo {
                    height: fit-content !important;
                    font-size: 18px;
                    font-weight: 500;
                    color: #00413C;
                    text-align: start;
                    width: 100%;
                }

                .grafico-cobertura-solo__container {
                    width: 100%;
                    display: flex;
                    gap: 8px;
                    padding: 0 8px !important;

                    .legenda-lateral-cobertura-solo {
                        min-width: 200px;
                        height: fit-content;
                        margin-top: 20px;

                        .item-legenda {
                            font-size: 14px
                        }
                    }

                    .grafico-cobertura-solo {
                        width: 100%;

                        .apexcharts-tooltip {
                            width: fit-content !important;
                            margin: 0 4px;
                            height: 45px !important;
                        }

                        .tooltip-cobertura-solo-content {
                            margin: 0 8px;
                        }
                        .tooltip-cobertura-solo-value {
                            font-size: 12px;
                            margin-top: -16px;
                        }
                        .tooltip-cobertura-solo-label {
                            font-size: 12px;
                            font-weight: 400 !important;
                        }
                    }
                }
            }

            .indicador__card {
                padding: 16px;
                background: white;
                border-radius: 5px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-items: center;
                font-size: 14px;
                font-weight: 500;
            }

            .grafico-territorios_container {
                width: 100%;
                height: 100%;

                .apexcharts-tooltip {
                    width: fit-content !important;
                    margin: 0 4px;
                    height: 45px !important;
                }

                .tooltip-territorios-content {
                    margin: 0 8px;
                }

                .tooltip-territorios-value {
                    font-size: 12px;
                    margin-top: -16px;
                }

                .tooltip-territorios-label {
                    font-size: 12px;
                    font-weight: 400 !important;
                }
            }

            .grafico-area-total_container {
                width: 100%;
                height: fit-content;

                .apexcharts-data-labels {
                    text {
                        font-family: 'Roboto', 'sans serif' !important;
                        font-weight: 400;
                        font-size: 14px !important;
                    }
                }

                .apexcharts-tooltip {
                    width: fit-content !important;
                    margin: 0 4px;
                    height: 45px !important;
                }

                .tooltip-area-total-content {
                    margin: 0 8px;
                }

                .tooltip-area-total-value {
                    font-size: 12px;
                    margin-top: -16px;
                }

                .tooltip-area-total-label {
                    font-size: 12px;
                    font-weight: 400 !important;
                }

                .apexcharts-legend {
                    height: fit-content;
                    padding-top: 18px !important;
                }

                .apexcharts-legend-series {
                    height: auto !important;
                    max-height: 32px;
                }
            }

            .titulo-indicador {
                height: 22px !important;
                font-size: 18px;
                font-weight: 500;
                color: #00413C;
            }

            .indicador-area-total {
                width: 100%;
                display: flex;
                justify-content: space-between;

                .titulo-indicador-valor-totalComPendencia {
                    height: 22px !important;
                    line-height: 27px;
                    font-size: 14px;
                }
            }

            .totalizadores__container {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                gap: 16px;
                padding-top: 16px;

                .totalizador-overview__card {
                    width: 100%;
                    height: 64px !important;
                    background-color: #f6f6f6 !important;
                    border-radius: 8px;
                    display: grid;
                    grid-template-columns: 28px 66% auto;
                    gap: 8px;
                    padding: 0 8px;

                    .totalizador-icon {
                        height: inherit;
                        display: flex;
                        justify-content: space-around;

                        img {
                            width: 22px;
                            margin-top: -2px;
                        }
                    }

                    .totalizador-label {
                        font-weight: normal;
                        height: fit-content;
                        line-height: 20px;
                        padding: 21px 0;
                        font-size: 13px;
                    }

                    .totalizador-valor {
                        height: inherit;
                        font-size: 20px;
                        text-align: right;
                        line-height: 20px;
                        padding: 21px 0;
                    }

                    .territorios-processados {
                        color: #00413C;
                        line-height: 20px;
                        padding: 20px 0;
                    }

                    .territorios-conformes {
                        color: #359138;
                    }

                    .territorios-regularizacao-ambiental {
                        color: #F88342;
                    }

                    .territorios-inconformes {
                        color: #dc362e;
                    }
                }
            }
        }
    }

    .lyra-icon::before {
        content: '';
        width: 24px;
        height: 25px;
        display: inline-block;
        background-color: var(--primary);
    }
}

.custom-header {
    .el-checkbox {
        display: flex;
        padding: 10px 15px;
        align-items: center;
        margin-bottom: 0 !important;
        border-bottom: 1px solid rgba(102, 102, 102, 0.18);
    }

    .is-checked {
        background-color: #DEF0B9 !important;
    }

    .el-checkbox:hover {
        background-color: #DEF0B9 !important;
    }
}

.el-select-dropdown__item.hover {
    background: white !important;
}

.el-select-dropdown__item:hover {
    background: #DEF0B9 !important;
}

.el-select-dropdown__item.selected {
    background-color: #DEF0B9 !important;
}

.el-tag.el-tag--info {
    background-color: #EBF4EB !important;
    border-color: #EBF4EB !important;
    color: #359138 !important;
    max-width: 100px !important;
    max-height: 40px !important;

    .el-tag__close {
        color: white !important;
        background: #359138 !important;
    }
}

.base-button-container {
    display: flex !important;
    gap: 20px;
}

.el-statistic .con {
    justify-content: flex-end !important;
}

.tooltip-inconforme {
    margin-left: 4px;
}

.tooltip-inconforme-descricao {
    p {
        text-align: justify !important;
    }
}
</style>
